import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from '@core/services/alert.service';
import { ClaimService } from '@core/services/claim.service';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { InboxService } from '@core/services/inbox.service';
import { LocaleService } from '@core/services/locale.service';
import { PolicyService } from '@core/services/policy.service';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { LOB } from '@shared/models/LOB';
import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { AkMessage } from '@shared/models/ak-message';
import { Claim } from '@shared/models/claim';
import { EmailUsTopics } from '@shared/models/email-us-topics';
import { Lob } from '@shared/models/lob-enum';
import { Policy } from '@shared/models/policy';
import { User } from '@shared/models/user';
import { MessagePreviewTextareaComponent } from 'az-customer-portal-ui';

@Component({
    selector: 'app-email-us',
    templateUrl: './email-us.component.html',
    styleUrls: ['./email-us.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '(window:resize)': 'onResize($event)'
    },
    standalone: false
})
export class EmailUsComponent implements OnInit {
    // lang
    private firstload = true;
 
    // form
    public form: FormGroup;
    public formBEValid = false;

    // topics and navigation
    public EmailUsTopics: EmailUsTopics;
    private secondLevelTopics;
    public topicData = [];
    public navList = [];

    public LOB = new LOB();

    // message component
    public isInReply = false;
    public textData = {
        "reply": "",
        "send": "",
        "download": "",
        "textAreaPlaceHolder": ""
    };
    //public photo = 'https://images.pexels.com/photos/106685/pexels-photo-106685.jpeg?cs=srgb&dl=pexels-mark-broadhurst-106685.jpg&fm=jpg';
    //public date = '11/02/2021 12:06 PM';

    private allowSetPolicy = true;
    private allowSetClaim = true;
    public selectedTopic = null;
    public selectedPolicy: Policy | null = null;
    public selectedClaim: Claim | null = null;
    // subject headline
    public subject = null;

    // textarea handler
    private message = null;
    private savedMessage = null;
    private deleteBtnClicked = false;
    private loggedUser: User;

    public allowedTopicPolicies = [
        '3'
    ];

    public allowedTopicClaims = [
        '1'
    ];

    private selectedRestricted = false;
    private restrictedSubjects = [
        'topic-insurance-supplementary',
        'topic-policy-update',
        'topic-policy-cancel'
    ];

    readonly lob: typeof Lob = Lob;
    public policies: {
        [policyNumber: string]: Policy;
    } = {};

    public claims: {
        [policyNumber: string]: {
            icon: string,
            claim: Claim;
        };
    } = {};

    public maxCountMessage = 4000;
    public countMessage = 0;

    constructor(
        private userService: UserService,
        private localeService: LocaleService,
        private router: Router,
        private dataService: DataService,
        private inboxService: InboxService,
        private alertService: AlertService,
        private translateService: TranslateService,
        private commonService: CommonService,
        private policyService: PolicyService,
        private claimService: ClaimService,
    ) {

        this.policyService.getActivePolicies().subscribe(activePolicies => {
            activePolicies.forEach((activePolicy) => {
                this.policies[activePolicy.policyNumber] = activePolicy;
            });

            this.claimService.getClaimsActive().subscribe(activeClaims => {
                activeClaims.forEach((activeClaim) => {
                    if (this.policies[activeClaim.policyNumber]) {
                        this.claims[activeClaim.claimNumber] = {
                            icon: this.getGroupByLobId(this.policies[activeClaim.policyNumber].lineOfBusinessId).icon,
                            claim: activeClaim,
                        };
                    }
                });

            });
        });

        this.EmailUsTopics = this.dataService.emailUsTopics;
        this.navList = this.dataService.emailUsNavList.filter(x => x.show == true);

        if (window.innerWidth < 704) {
            if (document.body.getElementsByClassName('footer').length == 1) {
                document.body.getElementsByClassName('footer').item(0).setAttribute("style", "display: none;");
            }

            if (document.body.getElementsByClassName('bottom-divider').length == 1) {
                document.body.getElementsByClassName('bottom-divider').item(0).setAttribute("style", "display: none;");
            }
        }
    }

    onResize(event) {
        if (event.target.innerWidth < 704) {
            if (document.body.getElementsByClassName('footer').length == 1) {
                document.body.getElementsByClassName('footer').item(0).setAttribute("style", "display: none;");
            }

            if (document.body.getElementsByClassName('bottom-divider').length == 1) {
                document.body.getElementsByClassName('bottom-divider').item(0).setAttribute("style", "display: none;");
            }
        } else {
            if (document.body.getElementsByClassName('footer').length == 1) {
                document.body.getElementsByClassName('footer').item(0).setAttribute("style", "display: flex;");
            }

            if (document.body.getElementsByClassName('bottom-divider').length == 1) {
                document.body.getElementsByClassName('bottom-divider').item(0).setAttribute("style", "display: flex;");
            }
        }
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            firstLevelTopic: new FormControl('', Validators.required),
            secondLevelTopic: new FormControl('', Validators.required),
            selectedSubject: new FormControl(''),
            policy: new FormControl(''),
            claim: new FormControl('')
        });

        this.userService.getLoggedUser().subscribe((res) => {
            this.loggedUser = res;
            this.localeService.activeLanguage.subscribe(language => {
                if (!this.firstload) {
                    // reload bc translations documents
                    this.reload();
                }

                this.firstload = false;
            });
        });
    }

    reload(){
        window.location.reload();
    }

    /**
     * Set Main Category
     */
    firstLevelBind(value) {
        this.secondLevelTopics = [];
        this.allowSetPolicy = false;

        if (this.form.get('firstLevelTopic').valid && this.form.get('firstLevelTopic').value != '') {

            if (this.selectedTopic != this.form.get('firstLevelTopic').value) {
                this.selectedTopic = this.form.get('firstLevelTopic').value;
                this.subject = null;
            }

            for (const x of this.EmailUsTopics.secondLevel) {
                if (Object.keys(this.claims).length == 0 && x.key == 'topic-other-claim') {
                    continue;
                }

                if (Object.keys(this.policies).length == 0 && this.selectedTopic == 3 && x.key !== 'topic-policy-other') {
                    continue;
                }

                if (this.form.get('firstLevelTopic').value == x.firstId) {
                    this.secondLevelTopics.push(x);
                }
            };
        }

        return this.secondLevelTopics;
    }

    /**
     * Set subject
     */
    secondLevelBind(value: string) {
        this.selectedPolicy = null;
        this.selectedClaim = null;
        this.form.get('policy').reset();
        this.form.get('claim').reset();

        this.allowSetPolicy = true;
        this.allowSetClaim = true;

        if (value != '') {
            if (this.restrictedSubjects.includes(value) && this.loggedUser.agentSource == 1) {

                this.selectedRestricted = true;
                this.commonService.agentSourceMsg();
            }
            else {

                this.selectedRestricted = false;
                this.EmailUsTopics.secondLevel.forEach(x => {

                    if (x.key == value) {
                        this.subject = x.name;
                    }
                });
            }
        }
    }


    /**
     * Set policy value from form
     */
    policyBind(policyNumber: string) {
        this.selectedPolicy = this.policies[policyNumber];
    }

    claimBind(claimNumber: string) {
        this.selectedClaim = this.claims[claimNumber].claim;
    }

    /*
     * Hide policies to change subject
     */
    editSubject() {
        this.allowSetPolicy = false;
        this.allowSetClaim = false;
    }

    /**
     * condition when to show policy selection
     */
    allowSelectedSubjectAndPolicies() {
        if (this.subject != null && this.subject.length > 0 && !this.subject.includes('topic-policy-other') && this.allowedTopicPolicies.includes(this.selectedTopic) && this.allowSetPolicy) {
            return true;
        }
        return false;
    }

    /**
     * condition when to show claims selection
     */
    allowSelectedSubjectAndClaims() {
        if (this.subject != null && this.subject.length > 0 && this.subject.includes('topic-other-claim') && this.allowedTopicClaims.includes(this.selectedTopic) && this.allowSetClaim) {
            return true;
        }

        return false;
    }

    /**
     * return ActiveInsuranceGroup (used for icon)
     */
    getGroupByLobId(lobId: number): ActiveInsuranceGroup {
        return this.dataService.activeInsuranceGroups.find(group => group.lobIds.some(x => x === lobId));
    }

    /**
     * Change topic
     */
    editTopic() {
        this.alertService.clear();
        this.message = document.getElementById('message-preview-text-area');
        this.savedMessage = this.message.value;
        this.isInReply = false;
    }

    /**
     * Set textarea message
     */
    clickSend() {
        this.message = document.getElementById('message-preview-text-area');
    }

    /**
     * Clear textarea
     */
    clickDelete() {
        this.deleteBtnClicked = true;
        if (this.message == null) {
            this.message = document.getElementById('message-preview-text-area');
        }

        this.message.value = "";
        this.countMessage = 0
    }

    /**
     * Submit
     */
    submit($event) {
        // restrictions
        if (this.selectedRestricted) {
            return;
        }

        // if policy has to be selected
        if (this.allowSelectedSubjectAndPolicies() && this.selectedPolicy == null) {
            return;
        }

        if (this.deleteBtnClicked) {
            this.deleteBtnClicked = false;
            return;
        }

        if (this.isInReply) {
            if (this.message.value.length < 10) {
                const options = {
                    autoClose: true
                };
                this.alertService.warn(this.translateService.instant('inbox.email-us.message-preview.additional.min-text-length'), options);
                return;
            }

            let akMessage = new AkMessage();
            if (this.selectedClaim) {
                akMessage.lobId = this.policies[this.selectedClaim.policyNumber].lineOfBusinessId;
            }

            if (this.selectedPolicy) {
                akMessage.lobId = this.selectedPolicy.lineOfBusinessId;
            }

            akMessage.topicKey = this.form.get('secondLevelTopic').value;
            akMessage.message = this.message.value;
            akMessage.policyNumber = this.selectedPolicy ? this.selectedPolicy.policyNumber : null;
            akMessage.claimNumber = this.selectedClaim ? this.selectedClaim.claimNumber : null;

            this.inboxService.postCreateAkMessage(akMessage).subscribe(res => {
                if (res instanceof AkMessage && Object.entries(res.errors).length > 0) {

                    for (const [key, value] of Object.entries(res.errors)) {
                        let err = {};
                        err[value] = true;
                        this.form.get(key).setErrors(err);
                    }

                } else {
                    this.formBEValid = true;
                    this.isInReply = false;
                    this.countMessage = 0
                }
            });
        }
        return;
    }

    /**
     * Show textarea
     */
    clickReply() {

        if (this.selectedRestricted) {
            return;
        }

        if (this.allowSelectedSubjectAndPolicies() && this.selectedPolicy == null) {
            this.form.get('policy').setErrors({ error: 'error' });
            return;
        }

        if (this.allowSelectedSubjectAndClaims() && this.selectedClaim == null) {
            this.form.get('claim').setErrors({ error: 'error' });
            return;
        }

        if (this.formBEValid) {
            this.router.navigate(['']);
        }

        if (this.form.get('firstLevelTopic').value == '') {
            this.form.get('firstLevelTopic').setErrors({ 'empty': true });
            this.form.get('secondLevelTopic').setErrors(null);
        } else {
            let valid = this.validateSecondTopic();
            if (valid == 0) {
                this.subject == null;
                this.form.get('secondLevelTopic').setErrors({ 'empty': true });
            }

            if (valid == 1) {
                this.alertService.clear();
                this.alertService.info(this.translateService.instant('inbox.email-us.notification.' + this.form.get('secondLevelTopic').value));
            }

            if (valid == 2) {
                this.isInReply = true;
                this.alertService.clear();
                //

                //this.message.value = this.savedMessage;
            }
        }

        setTimeout(() => {
            const msg = document.getElementById('message-preview-text-area');
            if(msg instanceof HTMLTextAreaElement){
                msg.addEventListener('input', (e) => {
                    

                    if(msg.value.length > this.maxCountMessage){
                        msg.value = msg.value.slice(0, this.maxCountMessage)
                    }

                    this.countMessage = msg.value.length
                })
            }
        }, 200)
    }

    getTranslatedTextData() {

        this.textData.reply = this.translateService.instant('inbox.email-us.message-preview.text-data.reply');
        if (this.formBEValid) {
            this.textData.reply = this.translateService.instant('inbox.email-us.result.btnText');
        }
        this.textData.download = this.translateService.instant('inbox.email-us.message-preview.text-data.download');
        this.textData.send = this.translateService.instant('inbox.email-us.message-preview.text-data.send');
        this.textData.textAreaPlaceHolder = this.translateService.instant('inbox.email-us.message-preview.text-data.textAreaPlaceHolder');

        return this.textData;
    }

    private validateSecondTopic() {
        let valid = 0;

        this.secondLevelTopics.forEach(x => {
            if (x.key == this.form.get('secondLevelTopic').value) {
                if (x.notification == true) {
                    valid = 1;
                } else {
                    valid = 2;
                }

            }
        });

        return valid;
    }


    changeRoute($event, component: string) {
        this.dataService.inboxSelectedComponent = component;
        this.router.navigate(['/inbox']);
    }

    /**
     * Not useful now
     */
    clickAttachment() { }
    clickDownload(filename) { }

}
